module.exports = __webpack_public_path__ + "static/media/1009420.a85c61c2.png";